/** Modal size scale — widths from Figma (`figmaComponentNodes.modal.page`). */
export const modalSizes = ['sm', 'md', 'lg', 'xl', 'table-preview'] as const;

export type ModalSize = (typeof modalSizes)[number];

export const modalDefaultSize: ModalSize = 'md';

/** Content `maxW` per size (Figma default modal = 450px → `md`). */
export const modalContentMaxWidth: Record<ModalSize, string> = {
  sm: '400px',
  md: '450px',
  lg: '600px',
  xl: '800px',
  'table-preview': 'calc(100vw - 350px)',
};
